import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyProps } from '@mui/material';
import { DirectoryLab } from './directory-browser-config';

/**
 * DD-3698: a clinic's place in a chain — "Part of <parent>" for a chain clinic, "<n>
 * clinics" for the parent. Nothing for an organization outside a chain.
 */
const DirectoryChainNote: FC<{ lab: DirectoryLab; variant?: TypographyProps['variant'] }> = ({
    lab,
    variant = 'body2',
}) => {
    const { t: translate } = useTranslation(['client-directory']);
    const text = lab.parent
        ? translate('client-directory:PART_OF', { name: lab.parent.name })
        : lab.clinicCount
          ? translate('client-directory:CHAIN_CLINIC_COUNT', { count: lab.clinicCount })
          : undefined;
    if (!text) return null;
    return (
        <Typography
            variant={variant}
            color="text.primary"
            noWrap
            title={text}
            data-test={`supplier-browser.chain-${lab._id}`}
        >
            {text}
        </Typography>
    );
};

export default DirectoryChainNote;
